import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetAccountManagerApiParameter extends ApiParameter {
    custommerId: string[];
}

const getAccountManagerUrl = "/api/v1/salesrepresentative";
const getCustomerManagerUrl = "/api/v1/customerrepresentative";

export function getAccountManager(parameter: GetAccountManagerApiParameter) {
    return get<any>(`${getAccountManagerUrl}/customerid/${parameter}`);
}

export function getCustomerManager(parameter: GetAccountManagerApiParameter) {
    return get<any>(`${getCustomerManagerUrl}/customerid/${parameter}`);
}
